import dom, { Fragment } from "../../../dist/jsx-render/dom"
import JSXComponent from "../../../dist/jsx-render/JSXComponent"
import { MsoTable } from "./MsoTable"
import { Columns } from "./Columns";
import { ColumnBase } from "./ColumnBase";
import { FlexHeaderCellComponent } from "./FlexHeaderCellComponent";
import { Settings } from "./Settings";
import { FlexContentRowComponent } from "./FlexContentRowComponent";
import { EditTypes } from "./EditTypes";
import { Constants } from "../../Common/constants";
import { ColumnDeleteIcon } from "./ColumnDeleteIcon";
import { TableColumnTypes } from "./TableColumnTypes";
import { ITableColumn } from "./ITableColumn";
import { FlexTableRowItem } from "./FlexTableRowItem";
import { app } from "../../Frame/App";
import { FlexFooterRowComponent } from "./FlexFooterRowComponent";

export type FlexTableComponentProps = {
    table: MsoTable;
    columns: Columns;
    enableSort: boolean;
    settings: Settings;
    models: any[];
    editType: EditTypes;
    idField: string;
    fixedLayout: boolean;
    fixedHeader: boolean;
    enableFilterPopup: boolean;
    enableScroll: boolean;
    enableDragDrop: boolean;
    posProperty: string;
    addFilter?: boolean;
    addButtonNew?: boolean;
    showDeleteButton?: boolean;
    flexCompleteWidth: boolean;
    enableFooter: boolean;
    /**Option to hide duplicate rows in the table (by row ID field) */
    hideDuplicatesOption?: boolean;
}

export class FlexTableComponent extends JSXComponent {
    private props: FlexTableComponentProps;
    private headerRow: HTMLTableRowElement;
    private headerCells: FlexHeaderCellComponent[] = [];
    private rowItems: FlexTableRowItem[] = [];
    private showMoreElement: HTMLElement;
    private footerComponent: FlexFooterRowComponent;
   

    constructor(props: FlexTableComponentProps) {
        super(props);
    }

    public get rowCount(): number {
        return this.rowItems.length;
    }

    private getClassName(): string {
        let result = "mt-header-row";
        if (this.props.fixedLayout && this.props.fixedHeader) {
            result += " sticky-top";
        }
        if (this.props.table.props.hideHeader) {
            result += " d-none";
        }
        return result;
    }

    private renderHeaderRow(): HTMLElement {
        if (this.props.table.props.onCreateCustomHeaderRow) {
            return this.props.table.props.onCreateCustomHeaderRow(this.props.columns.items);
        }
        else if (this.props.fixedLayout) {
            this.headerRow = (
                <tr className={this.getClassName()}>
                    {...this.renderHeaderCells()}
                </tr>
            )
        }
        else {
            this.headerRow = (
                <div className={this.getClassName()}>
                    <div className="mt-header-inner">
                        {...this.renderHeaderCells()}
                    </div>
                </div>
            )
        }
        return this.headerRow;
    }

    private renderHeaderCells(): HTMLElement[] {
        let result: HTMLElement[] = [];
        for (let col of this.props.columns.items) {
            let cell = new FlexHeaderCellComponent({
                column: col,
                enableSort: this.props.enableSort,
                settings: this.props.settings,
                table: this.props.table,
                enableFilterPopup: this.props.enableFilterPopup,
                enableScroll: this.props.enableScroll,
                fixedLayout: this.props.fixedLayout,
                flexTable: this,
                flexCompleteWidth: this.props.flexCompleteWidth
            });
            this.headerCells.push(cell);
            result.push(cell.render());
        }


        if (this.props.showDeleteButton) {
            let col = new ColumnDeleteIcon(this.props.table, this.createDeleteColumns(), this.props.table.id);
            col.width = Math.round(40 / window.devicePixelRatio);
            let cell = new FlexHeaderCellComponent({
                column: col,
                enableSort: this.props.enableSort,
                settings: this.props.settings,
                table: this.props.table,
                enableFilterPopup: this.props.enableFilterPopup,
                enableScroll: this.props.enableScroll,
                fixedLayout: this.props.fixedLayout,
                flexTable: this,
                flexCompleteWidth: this.props.flexCompleteWidth,
                
            });
            this.headerCells.push(cell);
            result.push(cell.render());
        }

        // add invisible column for scroll
        if (this.props.enableScroll && !this.props.flexCompleteWidth) {
            result.push(<div className="mt-invisible"></div>);
        }
        return result;
    }

    public createDeleteColumns(): ITableColumn {
        let deleteTableolumn: ITableColumn = { type: TableColumnTypes.DeleteIcon, dataField: "delete", number: this.props.columns.items.length, fixedWidth: Math.round(40 / window.devicePixelRatio) + "px" };
        return deleteTableolumn;
    }

    public createContentRow(rowItem: FlexTableRowItem): FlexContentRowComponent {
        return new FlexContentRowComponent({
            columns: this.props.columns,
            editType: this.props.editType,
            idField: this.props.idField,
            rowItem: rowItem,
            table: this.props.table,
            onRowClick: this.props.table.hasRowClick() ? this.props.table.onRowClick : undefined,
            useLock: this.props.table.useLock,
            fixedLayout: this.props.fixedLayout,
            enableDragDrop: this.props.enableDragDrop,
            flexTable: this,
            rowClickUrl: this.props.table.props.rowClickUrl,
            rowClickAllowedUrl: this.props.table.props.rowClickAllowedUrl
        });
    }

    private renderShowMoreElement(): HTMLElement {
        if (this.showMoreElement && this.showMoreElement.parentElement) {
            this.showMoreElement.parentElement.removeChild(this.showMoreElement);
        }

        this.showMoreElement = <div className="mt-show-more mt-content-row pointer"><div className="mt-cell">Mehr anzeigen</div></div>;
        this.showMoreElement.addEventListener("click", () => {
            this.showPartialContent(true);
        });
        return this.showMoreElement;
    }

    private renderContentRows(): HTMLElement[] {
        let result: HTMLElement[] = [];

        if (this.props.table.props.loadPartial) {
            let count: number = 0;

            let maxPartialRows = app.measuresLazyLoadingAmount ?? MsoTable.maxPartialRows;
            const lazyLoadingAmount: number = this.props.table.props.lazyLoadingAmount;
            if (lazyLoadingAmount > 0) {
                maxPartialRows = lazyLoadingAmount;
            }

            // do not render any rows, if sort is enabled
            // sort will render them
            //if (this.props.table.props.enableSort) {
            //    count = maxPartialRows;
            //}

            for (let model of this.props.models) {
                var rowItem = new FlexTableRowItem(this.props.table, model, null);
                if (!this.props.hideDuplicatesOption || !this.checkRowIsDuplicate(this.rowItems, rowItem)) {
                    if (count < maxPartialRows) {
                        rowItem.row = this.createContentRow(rowItem);
                    }
                    count++;
                    this.rowItems.push(rowItem);
                    if (rowItem.row) {
                        result.push(rowItem.row.render());
                        if (this.props.table.props.onRowCreated) {
                            this.props.table.props.onRowCreated(rowItem.row, model);
                        }
                    }
                }
            }

            if (count >= maxPartialRows) {
                result.push(this.renderShowMoreElement());
            }
        }
        else {
            for (let model of this.props.models) {
                var rowItem = new FlexTableRowItem(this.props.table, model, null);
                if (!this.props.hideDuplicatesOption || !this.checkRowIsDuplicate(this.rowItems, rowItem)) {
                    rowItem.row = this.createContentRow(rowItem);
                    this.rowItems.push(rowItem);
                    result.push(rowItem.row.render());
                    if (this.props.table.props.onRowCreated) {
                        this.props.table.props.onRowCreated(rowItem.row, model);
                    }
                }
            }
        }
        return result;
    }

    /**
     * Check if a row already exists with the same value in the ID field
     * @param itemList List of existing rows
     * @param row The row to be checked
     */
    private checkRowIsDuplicate = (itemList: FlexTableRowItem[], row: FlexTableRowItem) => {
        let duplicateFound = false;
        if (itemList.length > 0) {
            itemList.forEach(item => {
                if (item.modelId === row.modelId) {
                    duplicateFound = true;
                }
            })
        }

        return duplicateFound;
    }

    filterTextbox: HTMLElement = <div className="form-group">
        <input type="text" placeholder={Resources.Common.contains} className="mso-table-filter form-control" />
    </div>;

    private renderFooterRow(): HTMLElement {
        if (this.props.enableFooter) {
            this.footerComponent = new FlexFooterRowComponent({
                columns: this.props.columns,
                fixedLayout: this.props.fixedLayout,
                flexTable: this,
                idField: this.props.idField,
                enableScroll: this.props.enableScroll,
                flexCompleteWidth: this.props.flexCompleteWidth
            });
            return this.footerComponent.render();
        }
        return null;
    }
    
    element: HTMLElement;

    private renderFixed(): HTMLElement {
        return (
            <div className="table-container">
                {this.props.addFilter
                    ? this.filterTextbox
                    : []}
                <table className="mt-fix-table">
                    <thead className="mt-head">
                        {this.renderHeaderRow()}
                        {this.props.table.props.onCreateCustomSecondHeaderRow ? this.props.table.props.onCreateCustomSecondHeaderRow(this.props.columns.items) : ""}
                    </thead>
                    <tbody className="mt-body">
                        {...this.renderContentRows()}
                    </tbody>
                    {this.renderFooterRow()}
                </table>
            </div>
        )
    }

    private getInnerContentClassName(): string {
        let result = "mt-inner-content mt-body";
        if (this.props.enableScroll) {
            result += " mt-inner-scroll";
        }
        return result;
    }


    private renderFlex(): HTMLElement {
        return (
            <div className="table-container">
                {this.props.addFilter
                    ? this.filterTextbox
                    : []}
                <div className="mt-frame">
                    {this.renderHeaderRow()}
                    <div className="mt-content">
                        <div className={this.getInnerContentClassName()}>
                            {...this.renderContentRows()}
                        </div>
                    </div>
                    {this.renderFooterRow()}
                </div>
            </div>
        )
    }

    public getContentControl(): HTMLElement {
        if (this.props.fixedLayout) {
            return this.element.getElementsByClassName("mt-body").item(0) as HTMLElement;
        }
        else {
            return this.element.getElementsByClassName("mt-inner-content").item(0) as HTMLElement;
        }
    }

    public replaceRowItems(items: FlexTableRowItem[]): void {
        this.rowItems = items;
    }

    public showPartialContent(showMore: boolean = false): void {
        let maxPartialRows = app.measuresLazyLoadingAmount ?? MsoTable.maxPartialRows;
        const lazyLoadingAmount: number = this.props.table.props.lazyLoadingAmount;
        if (lazyLoadingAmount > 0) {
            maxPartialRows = lazyLoadingAmount;
        }

        // get content control and remove all content
        const contentControl = this.getContentControl();
        let startIndex: number = 0;

        if (showMore) {
            if (this.showMoreElement) {
                this.showMoreElement.parentElement.removeChild(this.showMoreElement);
            }

            // get last visible element id
            const lastRow = contentControl.lastElementChild;
            const lastItem = this.findRowsByElementId(lastRow.id);
            if (lastItem) {
                startIndex = this.rowItems.indexOf(lastItem.props.rowItem);
                if (startIndex < 0) {
                    startIndex = 0;
                }
                else {
                    startIndex++;
                }
            }
        }
        else {
            app.destroyDomChildren(contentControl);
            this.showMoreElement = null;
        }

        let count: number = 0;
        for (let index = startIndex; index < this.rowItems.length; index++) {
            const item = this.rowItems[index];
            if (item.isVisible) {
                if (item.row) {
                    contentControl.appendChild(item.row.element);
                }
                else {
                    item.row = this.createContentRow(item);
                    contentControl.appendChild(item.row.render());
                }
                count++;
                if (count >= maxPartialRows) {
                    break;
                }
            }
        }

        if (count >= maxPartialRows) {
            contentControl.appendChild(this.renderShowMoreElement());
        }

    }

    render(): HTMLElement {
        if (this.props.fixedLayout) {
            this.element = this.renderFixed();
        }
        else {
            this.element = this.renderFlex();

            // sync header row on horizontal scroll
            let scrollElement = this.element.querySelector(".mt-inner-content");
            scrollElement.addEventListener("scroll", () => {
                let left = scrollElement.scrollLeft;
                this.headerRow.scrollLeft = left;
                if (this.footerComponent) {
                    this.footerComponent.element.scrollLeft = left;
                }
            });
        }

        let filterTextbox = this.element.querySelector(".mso-table-filter") as HTMLInputElement;
        if (filterTextbox) {
            filterTextbox.addEventListener('keyup', this.filterTable)
        }

        // Attach mouseover events to all spans
        this.element.querySelectorAll("span").forEach(n => {
            (n as HTMLSpanElement).addEventListener("mouseover", this.onSpanMouseover);
        });

        this.updateFooter();

        return this.element;
    }

    private filterTable = (event: Event) => {
        let searchTerm = (event.target as HTMLInputElement).value?.toLocaleLowerCase();

        if (searchTerm && searchTerm.length > 2) {

            for (let item of this.rowItems) {
                if (item.row) {
                    for (let cell of item.row.cells) {

                        // cell -> span -> textnode -> value
                        var value = cell.firstChild?.firstChild?.nodeValue?.toLocaleLowerCase();

                        if (value && value.indexOf(searchTerm) > -1) {

                            item.row.element.classList.remove(Constants.cssClass_hidden);
                            break;
                        } else {
                            item.row.element.classList.add(Constants.cssClass_hidden);
                        }
                    }
                }
            }
        }
        else {
            this.element.querySelectorAll(".mt-content-row").forEach(e => e.classList.remove(Constants.cssClass_hidden));
        }
    }

    /**
     * Set new column width for all cells.
     * @param columnIndex Index of the column.
     * @param width New width as string.
     */
    setColumnWidth(columnIndex: number, width: string) {
        // update header
        if (this.headerRow) {
            (this.headerRow.firstElementChild.childNodes.item(columnIndex) as HTMLElement).style.width = width;
        }

        // update all content cells
        for (let item of this.rowItems) {
            if (item.row) {
                item.row.cells[columnIndex].style.width = width;
            }
        }

        // update footer
        if (this.footerComponent) {
            this.footerComponent.setColumnWidth(columnIndex, width);
        }
    }

    public findRowsById(id: string): FlexTableRowItem[] {
        let result: FlexTableRowItem[] = [];
        for (let item of this.rowItems) {
            if (item.modelId == id) {
                result.push(item);
            }
        }
        return result;
    }

    public findRowsByElementId(id: string): FlexContentRowComponent {
        for (let item of this.rowItems) {
            if (item.row && item.row.props.elementId == id) {
                return item.row;
            }
        }
        return null;
    }

    public getRowItems(): FlexTableRowItem[] {
        return this.rowItems;
    }

    removeRow(id: string) {
        let items = this.findRowsById(id);
        for (let item of items) {
            let index = this.rowItems.indexOf(item);
            if (index >= 0) {
                this.rowItems.splice(index, 1);
            }
            if (item.row) {
                const elementId = item.row.props.elementId;
                const rowElement = document.getElementById(elementId) as HTMLElement;
                rowElement.parentElement.removeChild(rowElement);
            }
        }
        this.updateFooter();
        if (this.props.enableDragDrop) {
            this.recalcPos();
        }
    }

    updateRow(model: any) {
        let id = model[this.props.idField];
        let items = this.findRowsById(id);
        if (items.length > 0) {
            for (let item of items) {
                item.model = model;
                if (item.row) {
                    item.row.updateRow(model);
                }
            }
        }
        else {
            this.addRow(model);
        }
        this.updateFooter();
    }

    addRow(model: any): FlexContentRowComponent {
        let rowItem = new FlexTableRowItem(this.props.table, model, null);
        rowItem.row = this.createContentRow(rowItem);
        this.rowItems.push(rowItem);
        this.getContentControl().appendChild(rowItem.row.render());
        this.updateFooter();
        return rowItem.row;
    }

    public recalcPos(): void {
        if (this.props.posProperty && this.props.posProperty.length > 0) {
            let content = this.getContentControl();
            let pos = 1;
            content.querySelectorAll(".mt-content-row").forEach((node: HTMLElement) => {
                if (node.hasAttribute("data-id")) {
                    let id = node.getAttribute("data-id");
                    let items = this.findRowsById(id);
                    if (items.length > 0) {
                        let item = items[0];
                        if (item.model[this.props.posProperty] != pos) {
                            item.model[this.props.posProperty] = pos;
                            if (this.props.table.props.onModelChanged) {
                                this.props.table.props.onModelChanged(this.props.posProperty, item.model);
                            }
                        }
                    }
                }
                pos++;
            });
        }
    }

    private onSpanMouseover = (event: MouseEvent) => {
        let span = event.target as HTMLSpanElement;

        if (span.offsetWidth < span.scrollWidth) {
            // Text was truncated, appenp title attribute for tooltip.

            //span -> text node -> nodeValue
            span.title = span.childNodes[0].nodeValue
        } else {
            span.removeAttribute("title");
        }
    }

    public updateFooter(): void {
        if (this.footerComponent) {
            this.footerComponent.updateValues(this.rowItems);
        }
    }

    /**
     * Toggle class 'use-ellipsis' (overflow hidden for text) when headerText > columnWidth.
     * @param columnIndex Index of the column.
     * @param width New width as string.
     */
    public lineBreakColumn(columnIndex: number, width: number) {
        if (this.headerRow) {
            let cellTextWidth;
            let headerElement = (this.headerRow.firstElementChild.childNodes.item(columnIndex) as HTMLElement);

            if (headerElement) {
                // calculate column title(text) width
                if (headerElement.classList.contains("use-ellipsis")) {
                    headerElement.classList.remove("use-ellipsis");
                    cellTextWidth = (headerElement.querySelector('.mt-cell-content > .mf-title') as HTMLElement).clientWidth;
                    headerElement.classList.add("use-ellipsis");
                } else
                    cellTextWidth = (headerElement.querySelector('.mt-cell-content > .mf-title') as HTMLElement).clientWidth;


                if (cellTextWidth > width) {
                    // update header
                    headerElement.classList.add("use-ellipsis");
                }
                else if (width > cellTextWidth && headerElement.classList.contains("use-ellipsis")) {
                    $(headerElement).toggleClass("use-ellipsis");
                }
            }
        }
    }
}